import { Box } from "@mui/material";
import { useState } from "react";

import EstimatorShell from "./EstimatorShell";
import Step1Type from "./Step1Type";
import Step2 from "./Step2";
import Step3Features from "./Step3Features";
import Step4Result from "./Step4Result";

const Estimator = () => {
  const [currentStep, setCurrentStep] = useState(1);

  const [estimatorData, setEstimatorData] = useState({
    projectType: null,

    // Step 2
    projectSize: null,
    pages: null,
    designLevel: null,
    roles: [],
    content: null,
    timeline: null,

    // Step 3
    features: [],
  });

  /* ---------------- STEP HANDLERS ---------------- */

  const handleStep1Next = (projectType) => {
    setEstimatorData((prev) => ({ ...prev, projectType }));
    setCurrentStep(2);
  };

  const handleStep2Next = (step2Data) => {
    setEstimatorData((prev) => ({ ...prev, ...step2Data }));
    setCurrentStep(3);
  };

  const handleStep3Next = (step3Data) => {
    setEstimatorData((prev) => ({ ...prev, ...step3Data }));
    setCurrentStep(4);
  };

  const handleBack = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 1));
  };

  /* ---------------- UI ---------------- */

  return (
    <Box id="estimator" sx={{ overflow: "clip" }}>
      {currentStep === 1 && (
        <EstimatorShell
          step={1}
          title="Choose Project Type"
          subtitle="Tell us what you want to build"
        >
          <Step1Type
            value={estimatorData.projectType}
            onChange={handleStep1Next}
          />
        </EstimatorShell>
      )}

      {currentStep === 2 && (
        <EstimatorShell
          step={2}
          title="Define Project Scope"
          subtitle="Help us understand size, complexity, and timeline"
        >
          <Step2
            data={estimatorData}
            onBack={handleBack}
            onNext={handleStep2Next}
          />
        </EstimatorShell>
      )}

      {currentStep === 3 && (
        <EstimatorShell
          step={3}
          title="Select Features"
          subtitle="Choose functionality required for your project"
        >
          <Step3Features
            data={estimatorData}
            onBack={handleBack}
            onNext={handleStep3Next}
          />
        </EstimatorShell>
      )}

      {currentStep === 4 && (
        <EstimatorShell
          step={4}
          title="Estimated Project Cost"
          subtitle="Based on your selections and industry benchmarks"
        >
          <Step4Result
            data={estimatorData}
            onRestart={() => setCurrentStep(1)}
          />
        </EstimatorShell>
      )}
    </Box>
  );
};

export default Estimator;
